import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 1.875rem 0;
  border-bottom: 2px solid ${({ theme }) => theme.palette.blue.light};
  height: 100%;
`;

const Header = styled.h2`
  font-size: 1rem;
  line-height: 1.0625;
  font-family: ${({ theme }) => theme.typography.headerFontFamily};
  margin: 0.625rem 0;
`;

const Name = styled.h3`
  font-size: 0.875rem;
  line-height: 1.0625;
  font-family: ${({ theme }) => theme.typography.headerFontFamily};
  margin: 0.625rem 0;
`;

const Details = styled.div``;

const Detail = styled.span`
  font-size: 0.875rem;
  line-height: 1.0625;
  font-family: ${({ theme }) => theme.typography.headerFontFamily};
`;
const Value = styled.span`
  font-size: 0.875rem;
  line-height: 1.0625;
  font-family: ${({ theme }) => theme.typography.bodyFontFamily};
`;

const DescHeader = styled.h5`
  font-size: 0.75rem;
  font-weight: 300;
  line-height: 1.0625;
  font-family: ${({ theme }) => theme.typography.headerFontFamily};
  margin: 0.625rem 0;
  color: ${({ theme }) => theme.palette.blue.main};
`;
const Desc = styled.p`
  font-size: 0.875rem;
  line-height: 1.0625;
  font-family: ${({ theme }) => theme.typography.headerFontFamily};
  color: ${({ theme }) => theme.palette.secondary.main};
`;

const ProjectDetails = ({ data, arupData }) => (
  <Container>
    {data ? (
      <div>
        <Header>Project details:</Header>
        <Name>{data.name}</Name>
        <Details>
          <Detail>Project location: </Detail>
          <Value>{data.location}</Value>
        </Details>
        <Details>
          <Detail>Project number: </Detail>
          <Value>{data.uniqueProjectNumber}</Value>
        </Details>
        <Details>
          <Detail>Project Business Area: </Detail>
          <Value>{data.projectUsageArea}</Value>
        </Details>
        <Details>
          <Detail>Project Type: </Detail>
          <Value>{data.projectUsageType}</Value>
        </Details>
        <DescHeader>Project description</DescHeader>
        <Desc>{data.description}</Desc>
      </div>
    ) : null}
    <Header>Specifier details:</Header>
    <Name>{arupData.fullName}</Name>
    <Details>
      <Detail>Company: </Detail>
      <Value>{arupData.company}</Value>
    </Details>
    <Details>
      <Detail>Address: </Detail>
      {arupData.address !== null ? (
        <Value>{arupData.address}</Value>
      ) : (
        <Value>-</Value>
      )}
    </Details>
    <Details>
      <Detail>Contact: </Detail>
      <Value>{arupData.workPhone}</Value>
      {arupData.mobileNumber === null || arupData.mobileNumber === '' ? null : (
        <div>
          <Detail>Mobile: </Detail>
          <Value>{arupData.mobileNumber}</Value>
        </div>
      )}
    </Details>
    <Details>
      <Detail>E-mail: </Detail>
      <Value>{arupData.email}</Value>
    </Details>
  </Container>
);

export default ProjectDetails;
